import { useQuery } from "react-query";

import * as reviewService from "api/services/reviewsService";

/**
 * Store server's state of review assignees
 *
 * @returns The query object returned by the useQuery hook
 */
export const useReviewAssignees = () =>
  useQuery(["review", "assignees"], () => reviewService.getAssignees(), {
    select: ({ data }) => data,
  });
